
import React, { useState } from "react";
import { Button } from "react-bootstrap";

const MenuItemButton = ({onClick, menuItemName}: {
  onClick: () => void;
  menuItemName: string;
}) => {
  return (
    <Button
      className="start-widget-tabs mobile-menu-item"
      onClick={onClick}
    >
      {menuItemName}
    </Button>
  )
}

const MobileHamburgerMenu = ({setShow, setShowForm, showForm}: {
  setShow: (show: string) => void;
  setShowForm: (showForm: boolean) => void;
  showForm: boolean;
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const clickedMenuItem = (menuItem: string) => {
    setIsOpen(false);
    setShow(menuItem);
  }

  return (
    <div className="mobile-menu">
      <Button
        onClick={() => setIsOpen(!isOpen)}
        className="hamburger-button"
      >
        <i className="fa fa-bars"/>
        <span style={{fontSize: "16px", width: "100%"}}>Quote Options</span>
      </Button>
      
      <div 
        className="hamburger-div"
        style={{
          opacity: isOpen ? 1 : 0,
          visibility: isOpen ? 'visible' : 'hidden',
          transform: isOpen ? 'translateY(0)' : 'translateY(-20px)',
        }}
      >
        <MenuItemButton 
          onClick={() => {
            setShowForm(!showForm);
            setIsOpen(false);
          }}
          menuItemName="Build Your Own Package"
        />
        <MenuItemButton onClick={() => clickedMenuItem("package-specials")} menuItemName="Package Specials"/>
        <MenuItemButton onClick={() => clickedMenuItem("request-quote")} menuItemName="Request Quote"/>
        <MenuItemButton onClick={() => clickedMenuItem("request-group-quote")} menuItemName="Request Group Quote"/>
        <MenuItemButton onClick={() => clickedMenuItem("find-reservation")} menuItemName="Find Quote"/>
      </div>
    </div>
  )
};

export default MobileHamburgerMenu;